/* eslint-disable eqeqeq */

import * as Yup from "yup";

export const validationSchema = function (docs, typeId, minDocs, maxDocs) {
  const yupObject = {};
  const minMaxString =
    minDocs == maxDocs ? minDocs : `between ${minDocs} and ${maxDocs}`;
  yupObject.docs = Yup.array().test({
    name: "Letters of Support Required",
    test(values) {
      if (
        !(
          Array.isArray(values) &&
          values.filter((doc) => doc.scholarship_doc_types_id == typeId)
            .length >= minDocs &&
          values.filter((doc) => doc.scholarship_doc_types_id == typeId)
            .length <= maxDocs
        )
      ) {
        return this.createError({
          path: "docs",
          message: `Please upload ${minMaxString} Letters of Support.`,
        });
      }

      return true;
    },
  });

  docs.forEach((doc) => {
    if (doc.scholarship_doc_types_id != typeId) {
      return;
    }
    const key = `docNote_${doc.scholarship_application_docs_id}`;
    yupObject[key] = Yup.string()
      .nullable()
      .test({
        name: "docNoteNotEmpty",
        test(value) {
          if (
            Object.prototype.toString.call(value) === "[object String]" &&
            value.replace(/<\/?[^>]+(>)/g, " ").match(/\S+/g) != null &&
            value.replace(/<\/?[^>]+(>)/g, " ").match(/\S+/g).length > 50
          ) {
            return this.createError({
              path: key,
              message: "Exceeded word count.",
            });
          }
          if (
            Object.prototype.toString.call(value) === "[object String]" &&
            value.match(/<gdiv[\s\S]*?>|<script[\s\S]*?>/gi)
          ) {
            return this.createError({
              path: key,
              message:
                "It appears that you are using a browser extension such as Ginger. This is unsupported by this application. Please remove the extension, restart your browser, and try again. For support, please contact sfu_uggla_scholars@sfu.ca",
            });
          }
          if (
            Object.prototype.toString.call(value) === "[object String]" &&
            value.length > 0
          ) {
            return true;
          }

          return this.createError({
            path: key,
            message: "Please answer all questions.",
          });
        },
      });
  });

  return Yup.object().shape(yupObject);
};

export const initialValues = function (docs) {
  const initialValuesObj = { docs: [] };
  docs.forEach((doc) => {
    const key = `docNote_${doc.scholarship_application_docs_id}`;
    initialValuesObj[key] = "";
  });
  // return {[editorName]: ""}
  return initialValuesObj;
};
